/**
 * Generate unique id
 *
 * @returns {string}
 */
const uniqid = (l = 'a') => l + Math.random().toString(16).substring(2, 11);

export default uniqid;